import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'

import Metadatos from '../publicaciones/Metadatos'
import { MensajeriaNew } from '../reutilizables/mensajeria/MensajeriaNew'

// servicios
import * as calificacionService from '../servicios/calificacionService'
import * as mensajesService from '../servicios/mensajesService'
import * as publicacionesService from '../servicios/publicacionesService'
import * as reputacionService from '../servicios/reputacionService'

import CalificacionProducto from './calificacionProducto/CalificacionProducto'
import Descripcion from './Descripcion'
import DetalleCabecera from './DetalleCabecera'
import InformacionVendedor from './InformacionVendedor'

const Detalle = (props) => {
  const [publicacion, setPublicacion] = useState(props.entidad)
  const [reputacion, setReputacion] = useState(0)
  const [calificacion, setCalificacion] = useState(0)
  const [mensajes, setMensajes] = useState([])
  const usuario = parseInt(localStorage.getItem('idUsuario'))

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const obtenerPublicacion = async (idPublicacion, idVendedor) => {
    const { data: publicacion } = await publicacionesService.buscarDetalle(idPublicacion)
    setPublicacion(publicacion)

    const { data: reputacion } = await reputacionService.buscarReputacion(idVendedor)
    setReputacion(reputacion)

    const { data: calificacion } =
      await calificacionService.buscarCalificacion(idPublicacion)
    setCalificacion(calificacion)
  }

  useEffect(() => {
    if (props.entidad.idPublicacion) {
      obtenerPublicacion(props.entidad.idPublicacion, props.entidad.idVendedor)
    }
  }, [props.entidad.idPublicacion])

  const muestraCalificacionProducto = () => {
    if (calificacion.length > 0) {
      return <CalificacionProducto calificacion={calificacion} />
    } else {
      return <></>
    }
  }

  const obtenerMensajes = async () => {
    const { data } = await mensajesService.buscarPorPublicacion(publicacion.idPublicacion)
    setMensajes(data)
  }

  useEffect(() => {
    obtenerMensajes()
  }, [])

  return (
    <>
      <DetalleCabecera detalle={publicacion} props={props} />
      <Descripcion descripcion={publicacion.descripcion} />
      <Metadatos idPublicacion={publicacion.idPublicacion}></Metadatos>
      {muestraCalificacionProducto()}
      <div className="row mt-4 " style={{ gap: '16rem' }}>
        <div className="col-md-6">
          <MensajeriaNew
            titulo={'Preguntas'}
            id={publicacion.idPublicacion}
            tipoDoc={'publicacion'}
            idVendedor={publicacion?.idVendedor}
            mensajes={mensajes}
            tipoMensajes={'preguntas'}
            usuario={usuario}
            idComprador={usuario}
            actualizarMensajes={obtenerMensajes}
          />
        </div>
        <div className="col-md-3">
          <InformacionVendedor
            reputacion={reputacion.length > 0 ? reputacion : 0}
            publicacion={publicacion}
          />
        </div>
      </div>
    </>
  )
}

Detalle.propTypes = {
  entidad: PropTypes.shape({
    idPublicacion: PropTypes.number.isRequired,
    idVendedor: PropTypes.number.isRequired
  }).isRequired
}

export default Detalle
